import { MQ_TABLET, Theme } from './src/constants/theme'

export const cardWithLeftHighlightStyles = ({ theme }) => ({
  '&::before': {
    backgroundColor: theme.primary,
    borderRadius: `${theme.borderRadius}px 0 0 ${theme.borderRadius}px`,
    bottom: 0,
    content: '""',
    left: 0,
    position: 'absolute' as 'absolute',
    top: 0,
    width: 20,
  },
  border: `1px solid ${theme.border}`,
  borderRadius: theme.borderRadius,
  color: theme.text,
  overflow: 'hidden',
  position: 'relative' as 'relative',
})

export const responsivePaddingStyles = (theme: Theme) => ({
  ...MQ_TABLET({
    paddingBottom: theme.padding,
    paddingTop: theme.padding,
  }),
  paddingBottom: theme.paddingMobile,
  paddingTop: theme.paddingMobile,
})
